import { render, staticRenderFns } from "./CohortFeedbackModal.vue?vue&type=template&id=4ad1710b"
import script from "./CohortFeedbackModal.vue?vue&type=script&lang=js"
export * from "./CohortFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./CohortFeedbackModal.vue?vue&type=style&index=0&id=4ad1710b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports